import script from "./TermsInc.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsInc.vue?vue&type=script&setup=true&lang=ts"

import "./TermsInc.vue?vue&type=style&index=0&id=64a0948c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64a0948c"]])

export default __exports__